import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { EntityMetadataGetRequestQuery, EntityMetadataGetResponse } from '@lio/api-types';

const getEntityMetadataQuery = (params: EntityMetadataGetRequestQuery) => {
  const query = new URLSearchParams();
  if (params['productOption.id']) {
    params['productOption.id'].forEach((item) => query.append('productOption.id', item));
  }
  if (params['productLabel.id']) {
    params['productLabel.id'].forEach((item) => query.append('productLabel.id', item));
  }
  if (params['jurisdiction.id']) {
    params['jurisdiction.id'].forEach((item) => query.append('jurisdiction.id', item));
  }
  if (params['writingCompany.id']) {
    params['writingCompany.id'].forEach((item) => query.append('writingCompany.id', item));
  }
  if (params['underwriter.id']) {
    params['underwriter.id'].forEach((item) => query.append('underwriter.id', item));
  }
  if (params['brokerage.id']) {
    params['brokerage.id'].forEach((item) => query.append('brokerage.id', item));
  }
  if (params['brokerageProducer.id']) {
    params['brokerageProducer.id'].forEach((item) => query.append('brokerageProducer.id', item));
  }
  if (params['offering.id']) {
    params['offering.id'].forEach((item) => query.append('offering.id', item));
  }
  if (params['quoteOrigin.id']) {
    params['quoteOrigin.id'].forEach((item) => query.append('quoteOrigin.id', item));
  }
  if (params['underwritingActivityType.id']) {
    params['underwritingActivityType.id'].forEach((item) => query.append('underwritingActivityType.id', item));
  }
  return query.toString();
};

export const useEntityMetadata = (params: EntityMetadataGetRequestQuery, enabled = true) => {
  const client = useClient();
  const query = getEntityMetadataQuery(params);
  const result = useQuery<EntityMetadataGetResponse, Error>({
    queryKey: ['entity-metadata', query], // THIS IS GETTING CALLED AS EMPTY on "return to quote page" from navigation. this CANNOT cache once as the search params have not loaded from the store. bad.
    queryFn: () => client.get(`entity-metadata?${query}`).json<EntityMetadataGetResponse>(),
    enabled,
  });
  return { ...result, entityMetadata: result.data };
};
